<template>
  <section class="table-sampler-memory-noise">
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Instrumento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Instrumento"
          v-model="model.instrument"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.instrument_serie"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.instrument_certificate"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.instrument_validity"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Calibrador</label>
        <input
          type="text"
          class="form-control"
          placeholder="Calibrador"
          v-model="model.gauge"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.gauge_serie"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.gauge_certificate"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.gauge_validity"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="2">
        <label>Data</label>
        <input
          type="text"
          class="form-control"
          placeholder="Data"
          v-model="model.date"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N. Medição</label>
        <input
          type="text"
          class="form-control"
          placeholder="N. Medição"
          v-model="model.medition"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Agente</label>
        <input
          type="text"
          class="form-control"
          placeholder="Agente"
          v-model="model.agent"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Tipo de ruído</label>
        <select
          type="text"
          class="form-control"
          v-model="model.noise_type"
          required
        >
          <option value="Ruído ocupacional">Ruído ocupacional</option>
        </select>
      </d-col>
      <d-col cols="2">
        <label>Método</label>
        <select
          type="text"
          class="form-control"
          v-model="model.method"
          required
        >
          <option value="NHO 01">NHO 01</option>
        </select>
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="2">
        <label>Limite de exposição</label>
        <select
          type="text"
          class="form-control"
          v-model="model.exposition_limit"
          required
        >
          <option value="NR 15 Anexo 1">NR 15 Anexo 1</option>
        </select>
      </d-col>
      <d-col cols="3">
        <label>Horário inicial</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário inicial"
          v-model="model.initial"
          required
        />
      </d-col>
      <d-col cols>
        <label>Horário final</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário final"
          v-model="model.final"
          required
        />
      </d-col>
      <d-col cols>
        <label>Calibração inicial</label>
        <input
          type="time"
          class="form-control"
          placeholder="Intervalo inicial"
          v-model="model.interval_initial"
          required
        />
      </d-col>
      <d-col cols>
        <label>Calibração final</label>
        <input
          type="time"
          class="form-control"
          placeholder="Intervalo final"
          v-model="model.interval_final"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="8">
        <label>Tarefa</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tarefa"
          v-model="model.task"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Duração</label>
        <input
          type="time"
          class="form-control"
          placeholder="Duração"
          v-model="model.duration"
          required
        />
      </d-col>
    </d-form-row>

    <epi-list :list.sync="model.epis"></epi-list>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Observações</label>
        <textarea
          type="text"
          class="form-control"
          placeholder="Observações"
          v-model="model.observation"
          required
        ></textarea>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { NOISE_MEMORY, _LOAD_MODEL_ } from '../../SampleModel';
import EpiList from '../EPIList.vue';

export default {
  name: 'Sample-Memory-Noise',
  props: {
    memory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(NOISE_MEMORY),
    };
  },
  components: {
    EpiList,
  },
  methods: {
    setModel() {
      if (this.memory) {
        this.model = this.memory;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:memory', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-memory-noise {
  label {
    margin-bottom: 0;
  }
}
</style>
